<template>
  <div class="modal-box">
    <div class="modal-body">
      <div class="report page cover">
        <img
          src="@/assets/images/element/dots-pattern.svg"
          alt=""
          class="top-dots"
        />
        <img
          class="logo"
          :src="
            spaceStore.currentSpace.image_id
              ? getImage(spaceStore.currentSpace.image_id)
              : '/images/logo-font-black.svg'
          "
          alt="Yuzu"
          data-convert="company_logo"
        />
        <div class="block">
          <div class="page-title">RAPPORT D'ÉVALUATION</div>
          <div class="candidate-name">
            {{ candidate.candidate.first_name }}
            {{ candidate.candidate.last_name }}
          </div>
          <p>
            <span class="bold">Campagne associé :</span> {{ campaign_name }}
          </p>
          <p>
            <span class="bold">Rapport exporté le :</span> {{ current_date }}
          </p>
        </div>
        <div class="footer">
          <img src="/images/logo-font-black.svg" alt="Yuzu" />
          Yuzu Assessement © 2025 - Tous droits réservés.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getDate } from "@/composables/utils.js";
import { useSpaceStore } from "@/stores/space.js";
import { computed } from "vue";
import { getImage } from "@/composables/getImage.js";

const spaceStore = useSpaceStore();

defineProps({
  candidate: {
    type: Object,
    required: true,
  },
  campaign_name: {
    type: String,
    required: true,
  },
});

const current_date = computed(() => {
  return getDate(new Date(), "dddd DD MMMM YYYY");
});
</script>
